import * as React from 'react';
import {connect} from 'react-redux';

import {Session} from 'nutshell-core/session';

import {ActionMenu} from 'shells/action-menu/action-menu';
import type {SelectMenuOption} from 'shells/action-menu/action-menu';

import type {NutshellState} from '../../../store';

import {Notifies} from '../../entity-list/footer/notifies';

import styles from './title-bar-action-button.module.css';

type OwnProps = {
    exportOptions: Array<SelectMenuOption>;
    showNotification: boolean;
};
type StateProps = {
    validNotifies: Array<any>;
};
type DispatchProps = {
    onAcknowledgeExportDownload: () => any;
};
type Props = OwnProps & StateProps & DispatchProps;

function mapStateToProps(state: NutshellState): StateProps {
    return {
        validNotifies: Session.getSessionStateUserUnacknowedgedExportNotifications(state),
    };
}

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        onAcknowledgeExportDownload: () => {
            dispatch(Session.requestFetchSession());
        },
    };
}

export class TitleBarActionButtonComponent extends React.PureComponent<Props> {
    render() {
        return (
            <React.Fragment>
                <ActionMenu
                    options={this.props.exportOptions}
                    showAsButton={true}
                    buttonText='Download'
                />
                {this.props.validNotifies.length && this.props.showNotification ? (
                    <div className={styles['export-download-container']}>
                        <Notifies
                            notifies={this.props.validNotifies}
                            onAcknowledgeExportDownload={this.props.onAcknowledgeExportDownload}
                        />
                    </div>
                ) : undefined}
            </React.Fragment>
        );
    }
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);

export const TitleBarActionButton = connector(TitleBarActionButtonComponent);
